import { Component, OnInit, Self } from "@angular/core";
import { Validators } from "@angular/forms";
import { EntityModalComponent } from "../../../util/components/modal/entity-modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ClientDto, NameDto, OfficeNameDto } from "app/api/models";
import { CaslAction } from "app/server/enums/casl-action.enum";
import { EntityTyp } from "app/util/enums/entity-typ.enum";
import { EmployeeService, HousingService } from "app/api/services";
import { ClientFormGroupService } from "../client-form-group.service";
import { EnumDropdownOption, EnumService } from "../../../util/service/enum.service";
import { AuthService } from "../../../util/service/auth.service";
import { UserRole } from "app/server/enums/user-role.enum";
import { DownloadService } from "../../../util/service/download.service";
import { ReportEntryCategory } from "app/server/enums/report-entry-category.enum";
import { ModalService } from "../../../util/service/modal.service";
import { OfficeType } from "../../../server/enums/office-type.enum";

@Component({
  selector: "app-client-modal",
  templateUrl: "./client-modal.component.html",
  styleUrl: "./client-modal.component.scss",
  providers: [ClientFormGroupService],
  standalone: false,
})
export class ClientModalComponent extends EntityModalComponent<ClientDto> implements OnInit {
  constructor(
    @Self() public formGroupService: ClientFormGroupService,
    public modal: NgbActiveModal,
    private housingService: HousingService,
    private employeeService: EmployeeService,
    private enumService: EnumService,
    public authService: AuthService,
    public downloadService: DownloadService,
    private modalService: ModalService
  ) {
    super();
  }
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;
  protected readonly UserRole = UserRole;
  protected readonly ReportEntryCategory = ReportEntryCategory;

  offices!: OfficeNameDto[];
  housings!: NameDto[];
  employees!: NameDto[];
  clientStati: EnumDropdownOption[];

  override ngOnInit(): void {
    this.offices = this.data["offices"];
    this.clientStati = this.enumService.clientStatusDropdownOptions;

    super.ngOnInit();

    if (!this.formGroupService.officeId && this.offices.length === 1) {
      this.formGroupService.officeIdFormControl.setValue(this.offices[0].id);
    }

    this.initHousings(this.data?.entity?.officeId, this.data?.entity?.housingId, true);
    this.initEmployees(this.data?.entity?.officeId, this.data?.entity?.caregivers, true);
    this.updateStatusValidator();

    this.formGroupService.officeIdFormControl.valueChanges.subscribe((officeId: number) => {
      this.getClients(officeId);
      this.updateStatusValidator();
    });
  }

  private getClients(officeId?: number) {
    this.formGroupService.housingIdFormControl.reset();
    this.initHousings(officeId, this.formGroupService.housingId, false);
    this.formGroupService.caregiversFormControl.reset([]);
    this.initEmployees(officeId, this.formGroupService.caregivers, false);
  }

  private initHousings(officeId: number, housingId: number, initial: boolean) {
    this.housings = [];
    if (officeId) {
      this.housingService
        .housingControllerFindAllDropdown({ officeId, sIds: [housingId], initial })
        .subscribe((housing) => {
          this.housings = housing;
        });
    }
  }

  private initEmployees(officeId: number, employeeIds: number[], initial: boolean) {
    this.housings = [];
    if (officeId) {
      this.employeeService
        .employeeControllerFindAllDropdown({ officeId, sIds: employeeIds, initial })
        .subscribe((employees) => {
          this.employees = employees;
        });
    }
  }

  async openTimeframeModal(client: ClientDto) {
    const timeframe = await this.modalService.openTimeframeModal();
    if (timeframe) {
      return this.downloadService.downloadKlientenbericht(client.id, client.firstName, client.lastName, timeframe);
    }
  }

  private updateStatusValidator(): void {
    const statusControl = this.formGroupService.statusFormControl;
    if (this.getCurrentOfficeType() === OfficeType.KJH) {
      statusControl.clearValidators();
    } else {
      statusControl.setValidators(Validators.required);
    }
    statusControl.updateValueAndValidity();
  }

  getCurrentOfficeType(): OfficeType | undefined {
    return this.offices.find((o) => {
      return o.id === this.formGroupService.officeIdFormControl.value;
    })?.type as OfficeType | undefined;
  }

  protected readonly OfficeType = OfficeType;
}
